export enum MemberMetaDataEnum {
    UPGRADESKIPPEDCOUNT = 'UpgradeSkippedCount',
    BWPENABLED ="BWPEnabled"
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/member-meta-data.enum.ts